import React from "react";
import { observer } from "mobx-react";
import Literal from "../input/Literal";
import { Grid, TextField } from "@mui/material";

const ShortTextEditor = ({
  title,
  value,
  required,
  viewonly = false,
  viewframe = true,
  updatefunc,
  style = {},
  placeholder = "",
  onKeyDown = () => {},
}) => {
  const onChange = (e) => {
    if (e.target.value.length < 450) {
      updatefunc(e.target.value);
    } else {
      updatefunc(e.target.value.substr(0, 449));
    }
  };

  return (
    <React.Fragment>
      {!viewonly && viewframe && (
        <Grid container direction="column" spacing={0}>
          <Grid item>
            <label>{required ? title + " *" : title}</label>
          </Grid>
          <Grid item style={{ marginBottom: 5 }}>
            <TextField
              data-cy={"TextField_" + title}
              placeholder={placeholder !== "" ? placeholder : "Type..."}
              inputProps={{
                style: {
                  padding: 10,
                  boxSizing: "border-box",
                  height: 38,
                  ...style,
                },
              }}
              InputProps={{
                style: {
                  background: value && value.trim() !== "" ? "#fff" : "#f5f5f5",
                },
              }}
              variant="filled"
              value={value}
              onChange={onChange}
              onKeyDown={onKeyDown}
              fullWidth={true}
            />
          </Grid>
        </Grid>
      )}
      {!viewonly && !viewframe && (
        <TextField
          data-cy={"TextField_" + title}
          value={value}
          placeholder={placeholder !== "" ? placeholder : "Type..."}
          onChange={onChange}
          InputProps={{
            style: {
              background: value && value.trim() !== "" ? "#fff" : "#f5f5f5",
            },
          }}
          inputProps={{
            style: {
              padding: 10,
              boxSizing: "border-box",
              height: 38,
              ...style,
            },
          }}
          onKeyDown={onKeyDown}
          required={required}
          fullWidth={true}
        />
      )}
      {viewonly && <Literal title={title} text={value} />}
    </React.Fragment>
  );
};
export default observer(ShortTextEditor);
